
import { AvailableChart, Dashboard } from '@/types/DashboardServiceType'
import { MenuItems } from '@/types/utilTypes'
import axios from 'axios'
import { ILoggingService } from './LoggingService'

export default class DashboardService {
    private readonly _logging: ILoggingService
    private readonly baseUrl = '/dashboards'

    constructor(logging: ILoggingService) {
        this._logging = logging
    }

     public async getAvailableDashboards(): Promise<MenuItems<Dashboard>> {
        try {
            return (await axios.get(this.baseUrl)).data
        } catch(error){
            this._logging.LogError(this.baseUrl, error)
            throw error
        }
     }

    public async getDefaultDashboard(): Promise<Dashboard> {
        const url = `${this.baseUrl}/default`

        try {
            return (await axios.get(url)).data
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }

   
    public async getAvailableCharts(): Promise<AvailableChart[]> {
        const url = `${this.baseUrl}/charts`

        try {
            return (await axios.get(url)).data.result
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }

    }

    public async upsertDashboard(dashboard: Dashboard): Promise<string | null> {
        try {
            return (await axios.post(this.baseUrl, dashboard)).data.result
        } catch(error){
            this._logging.LogError(this.baseUrl, error)
            throw error
        }
    }

    public async deleteDashboard(dashboardId: string): Promise<void> {
        try {
            await axios.delete(`${this.baseUrl}/${dashboardId}`)
        } catch(error){
            this._logging.LogError(this.baseUrl, error)
            throw error
        }
    }
}